var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#5834A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 0.832031C4.04767 0.832031 0.833008 4.04736 0.833008 7.9987C0.833008 11.95 4.04767 15.1654 7.99967 15.1654C11.9517 15.1654 15.1663 11.95 15.1663 7.9987C15.1663 4.04736 11.9517 0.832031 7.99967 0.832031ZM7.99967 14.1654C4.59901 14.1654 1.83301 11.3994 1.83301 7.9987C1.83301 4.59803 4.59901 1.83203 7.99967 1.83203C11.4003 1.83203 14.1663 4.59803 14.1663 7.9987C14.1663 11.3994 11.4003 14.1654 7.99967 14.1654ZM10.6863 6.08936C10.8817 6.28469 10.8817 6.60138 10.6863 6.79671L7.57501 9.90804C7.47768 10.0054 7.34968 10.0547 7.22168 10.0547C7.09368 10.0547 6.96568 10.006 6.86835 9.90804L5.31301 8.3527C5.11768 8.15737 5.11768 7.84068 5.31301 7.64535C5.50834 7.45001 5.82501 7.45001 6.02035 7.64535L7.22235 8.84737L9.97968 6.09005C10.175 5.89471 10.491 5.89469 10.6863 6.08936Z",
    fill: "#5834A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnread);
export default __webpack_public_path__ + "static/media/unread.a12b281124a4603e1b8623f9dcf76c48.svg";
export { ForwardRef as ReactComponent };